import React, { Component, Fragment } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import URC from 'ui-react-common';
import Loadable from 'react-loadable';
import SVG from 'react-inlinesvg';
import ApplicationPage from '../pages/application-page/Application';
import WrappedApplicationPage from '../pages/wrapped-application-page/WrappedApplicationPage';
import ProdConfig from '../components/prod-config/ProdConfig';
import PIIRetryPage from '../pages/pii-retry-page/PIIRetryPage';
import ChatScript from '../components/chat-script/ChatScript';
import '../../node_modules/ui-sdk/source/images/D-SparkCoreIcons.svg';
import sparkIcons from '../../node_modules/ui-sdk/source/images/D-SparkCoreIcons.svg';

const config = URC.config;
const { baseName } = config;
const { mapping, errorRoute, PrivateRoute } = URC.ui.components.routing;

const OffersPage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "offerspage" */ '../pages/offers-page/OffersPage'),
    loading: () => null,
});

const RegistrationPage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "registrationpage" */ '../pages/registration-page/RegistrationPage'),
    loading: () => null,
});

const CreditFreezePage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "creditfreezepage" */ '../pages/credit-freeze-page/CreditFreeze'),
    loading: () => null,
});

const PageNotFoundPage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "pagenotfoundpage" */ '../pages/page-not-found-page/PageNotFoundPage'),
    loading: () => null,
});

const ServerErrorPage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "servererrorpage" */ '../pages/server-error-page/ServerErrorPage'),
    loading: () => null,
});

const FraudErrorPage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "frauderrorpage" */ '../pages/fraud-error-page/FraudErrorPage'),
    loading: () => null,
});

const AccountExistsPage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "accountexistspage" */ '../pages/account-exists-page/AccountExistsPage'),
    loading: () => null,
});

const LeadRegisterPage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "leadregisterpage" */ '../pages/lead-register-page/LeadRegisterPage'),
    loading: () => null,
});

const LeadCompletePage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "leadcompletepage" */ '../pages/lead-complete-page/LeadCompletePage'),
    loading: () => null,
});

const EmailInUsePage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "emailinusepage" */ '../pages/email-in-use-page/EmailInUsePage'),
    loading: () => null,
});

const { ScrollToTop } = URC.ui.containers;
const { RoutingSubscriber } = URC.ui.containers.routingSubscriber;
const { webUIRoot, webUIUrl } = config;

class ApplicationFlowRouter extends Component {
    constructor(props) {
        super(props);
        this.checkAndUpdateBadHashLinks();
    }

    checkAndUpdateBadHashLinks() {
        // redirect pages without pattern index.html#
        const { hash, href, search } = window.location;
        if (!hash || !href.includes('index.html#')) {
            // Redirect to the known page with the hash
            window.location.href = `/inq/index.html#/${search}`;
        }
    }

    render() {
        return (
            <BrowserRouter basename={baseName}>
                <RoutingSubscriber routerMapping={mapping} errorRoute={errorRoute}>
                    <Fragment key="appContainer">
                        <ScrollToTop>
                            <div className="global-nav-wrapper">
                                <global-nav />
                            </div>
                            <Switch>
                                <Route exact path="/" component={ApplicationPage} />
                                <Route exact path="/rocketaccountapply" component={WrappedApplicationPage} />
                                <PrivateRoute path="/pii" component={PIIRetryPage} />
                                <PrivateRoute path="/offers" component={OffersPage} />
                                <PrivateRoute path="/leadcomplete" component={LeadCompletePage} />
                                <PrivateRoute path="/emailinuse" component={EmailInUsePage} />
                                <PrivateRoute path="/register" component={RegistrationPage} />
                                <PrivateRoute path="/leadregister" component={LeadRegisterPage} />
                                <PrivateRoute path="/credit-freeze" component={CreditFreezePage} />
                                <PrivateRoute path="/credit-freeze-tu" component={CreditFreezePage} />
                                <PrivateRoute path="/credit-freeze-eq" component={CreditFreezePage} />
                                <Route path="/contact-us/:errorCode?" component={ServerErrorPage} />
                                <Route path="/cannot-process" component={FraudErrorPage} />
                                <Route path="/account-exists" component={AccountExistsPage} />
                                <Route component={PageNotFoundPage} />
                            </Switch>
                            <global-footer />
                            <SVG
                                src={sparkIcons}
                                uniquifyIDs={false}
                            />
                            <ProdConfig />
                            <ChatScript config={config.five9Config} />
                        </ScrollToTop>
                    </Fragment>
                </RoutingSubscriber>
            </BrowserRouter>
        );
    }
}

export default ApplicationFlowRouter;
